import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'home-fitness-studio-workout-list',
  templateUrl: './home-fitness-studio-workout-list.component.html',
  styleUrls: ['./home-fitness-studio-workout-list.component.scss']
})
export class HomeFitnessStudioWorkoutListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
